import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Outlet } from 'react-router-dom';
import { SITE_DEFAULT_LANG } from '../config/site';
import MainNav from './MainNav';
import SiteFooter from './SiteFooter';
import StickyCTA from './StickyCTA';

export default function Layout() {
  return (
    <div className="page">
      <Helmet htmlAttributes={{ lang: SITE_DEFAULT_LANG }} />
      <MainNav />
      <Outlet />
      <SiteFooter />
      <StickyCTA />
    </div>
  );
}
